import { render, staticRenderFns } from "./update_userInfo_ca.vue?vue&type=template&id=4efbaa76&scoped=true&"
import script from "./update_userInfo_ca.vue?vue&type=script&lang=js&"
export * from "./update_userInfo_ca.vue?vue&type=script&lang=js&"
import style0 from "./update_userInfo_ca.vue?vue&type=style&index=0&id=4efbaa76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efbaa76",
  null
  
)

export default component.exports